import { Tab } from '../../store/data-management-store/data-management-store.type';

/**
 * Extracts a Tab value from URL search params, returning null if the param
 * is absent or not a recognised Tab value.
 *
 * Used by DataManagement to support deep-linking:
 *   /application/data-management?tab=data-sources
 *
 * @param {URLSearchParams} params - The current URL search params
 * @returns {Tab | null} The matching Tab, or null if not found/invalid
 */
function getTabFromSearchParams(params: URLSearchParams): Tab | null {
  const value = params.get('tab');
  if (!value) return null;
  const validTabs = Object.values(Tab) as string[];
  if (validTabs.includes(value)) return value as Tab;
  return null;
}

export { getTabFromSearchParams };
